import { notImplemented } from '@intercom/pulse/lib/computed-properties';
import $ from 'jquery';
import { bind, schedule } from '@ember/runloop';
import Em from 'ember';
export default Em.Mixin.create({
  showAttributeImputInserter: false,
  editorValuePath: notImplemented(),
  setupExternalClickHandlers: Em.on('didInsertElement', function () {
    $('body').on(`mousedown.${this.get('elementId')}`, bind(this, this.bodyClickHandler));
  }),
  bodyClickHandler(e) {
    if ($(this.element) && $(this.element).has(e.target).length === 0 && !this.isDestroyed && !this.isDestroying) {
      this.set('showAttributeInserter', false);
    }
  },
  willDestroyElement() {
    $('body').off(`mousedown.${this.get('elementId')}`);
  },
  createAttributeTemplate(attribute, placeholder) {
    let template;
    if (attribute.noFallback) {
      template = `{{ ${attribute.get('templatable_identifier')} }}`;
    } else {
      template = `{{ ${attribute.get('templatable_identifier')} | fallback:"${placeholder}" }}`;
    }
    return template;
  },
  addAttributeToInput(property, template) {
    let inputValue = this.get(property) || '';
    let position = this.get('caretPosition');
    inputValue = inputValue.substr(0, position) + template + inputValue.substr(position);
    this.set(property, inputValue);
  },
  focusAttribute(placeholder) {
    let input = $('input:first', this.element)[0];
    let selectionStart = input.value.indexOf(placeholder);
    if (selectionStart >= 0) {
      input.setSelectionRange(selectionStart, selectionStart + placeholder.length);
    }
    input.focus();
  },
  addAttributeAndFocus(attribute, property) {
    let placeholder = '_REPLACE_THIS_';
    let template = this.createAttributeTemplate(attribute, placeholder);
    this.addAttributeToInput(property, template);
    schedule('afterRender', this, function () {
      this.focusAttribute(placeholder);
    });
  },
  actions: {
    insertAttribute(attribute) {
      this.set('showAttributeInserter', false);
      this.addAttributeAndFocus(attribute, this.get('editorValuePath'));
    },
    toggleAttributeInserter() {
      this.toggleProperty('showAttributeInserter');
    }
  }
});